import {
    Action,
    AsyncThunkPayloadCreator,
    createAsyncThunk,
    miniSerializeError,
    SerializedError,
} from '@reduxjs/toolkit';
import {combineEpics, Epic} from 'redux-observable';
import {catchError} from 'rxjs/operators';

import {isObject} from '~shared/utils';

import toaster, {ToastProps} from '~ui/utils/toaster';

import type {WikiThunkExtra} from './deps';
import type {WikiEpic} from './types';

export interface ThunkSerializedError extends SerializedError {
    status?: unknown;
    details?: unknown;
}

export function createThunk<Returned, ThunkArg = void>(
    typePrefix: string,
    payloadCreator: AsyncThunkPayloadCreator<
        Returned,
        ThunkArg,
        {extra: WikiThunkExtra; serializedErrorType: ThunkSerializedError}
    >,
) {
    return createAsyncThunk(typePrefix, payloadCreator, {
        serializeError: (error) => {
            // default redux-toolkit serialize function
            // https://redux-toolkit.js.org/api/other-exports#miniserializeerror
            const serializedError = miniSerializeError(error);

            const {details = undefined, status = undefined} = isObject(error) ? error : {};

            return {...serializedError, details, status};
        },
    });
}

export function makeThunkErrorHandler(options: Omit<ToastProps, 'type'>) {
    return function thunkErrorHandler(error: unknown) {
        toaster.createToast({type: 'error', ...options});

        console.error('[thunk error]:', error);

        // throw error to make thunk rejected
        throw error;
    };
}

export function createRootEpic(...epics: WikiEpic[]): Epic<Action> {
    return (...args) =>
        combineEpics(...epics)(...args).pipe(
            catchError((error, source) => {
                console.error(error);
                // Если произошла неведомая ошибка,
                // ПЕРЕЗАПУСКАЕМ source в котором она произошла
                return source;
            }),
        );
}
